module.exports = __webpack_public_path__ + "img/redness_4.fb4310e4.png";